import { isDefined } from "@clipboard-health/util-ts";
import sendbirdSelectors from "@sendbird/uikit-react/sendbirdSelectors";
import type useSendbirdStateContextHook from "@sendbird/uikit-react/useSendbirdStateContext";
import { APP_V2_APP_EVENTS, logError } from "@src/appV2/lib/analytics";

export interface SendMessageToFacilityProps {
  messageToFacility: string;
  sendBirdStateContext: ReturnType<typeof useSendbirdStateContextHook>;
  workplaceId: string;
  workerId: string;
}

export async function sendMessageToFacility(params: SendMessageToFacilityProps) {
  const { messageToFacility, sendBirdStateContext, workplaceId, workerId } = params;

  const sdk = sendBirdStateContext?.stores?.sdkStore?.sdk;
  const sendUserMessage = sendbirdSelectors.getSendUserMessage(sendBirdStateContext);

  if (!isDefined(workplaceId) || !isDefined(sdk) || !isDefined(sdk.groupChannel)) {
    logError("Failed to send message to facility via Sendbird", {
      error: "Sendbird is not available",
    });
    return;
  }

  const channel = await sdk.groupChannel.getChannel(`${workplaceId}_${workerId}`);
  try {
    sendUserMessage(channel, { message: messageToFacility });
  } catch (error) {
    logError(APP_V2_APP_EVENTS.SEND_MESSAGE_TO_WORKPLACE_FAILURE, {
      error,
      metadata: {
        messageToFacility,
        workplaceId,
        workerId,
      },
    });
  }
}
